import dayjs from 'dayjs';
import Image from 'next/image';

import Text from '~components/Text';
import useMedia from '~hooks/useMedia';
import { CompanyStates, SalesSource, SummarySales } from '~types/company';
import { getSalaryRate } from '~utils/company/company';
import { numberToKorean } from '~utils/formatted/number';
import { isEmpty } from '~utils/lodash/isEmpty';

import { S } from './style';

interface Props {
  sales: SummarySales;
  companyStates: CompanyStates;
}
function SalesCard({ sales, companyStates }: Props) {
  const { isMobile } = useMedia();
  function displaySales(salesData: number, type: 'person' | 'salary' | 'total') {
    if (typeof salesData !== 'number' || !salesData || salesData === 0) {
      return '정보없음';
    }

    return numberToKorean(salesData, type);
  }
  const rate = getSalaryRate(sales.rate ?? 0);

  return (
    <S.SummaryCardItem>
      <S.Label>
        <img src={`/images/${isMobile ? 'sales_m.png' : 'sales.png'}`} alt='money' />
        <S.Title typography='midium150_C1'>총 매출액</S.Title>
      </S.Label>
      {companyStates.sales ? (
        <S.Content>
          <S.TitleWrapper isEmpty={isEmpty(sales.total)}>
            <Text typography={isMobile ? 'bold150_T1' : 'bold150_B1'}>
              {displaySales(sales.total, 'total')}
            </Text>
            {rate && rate <= 50 && !isEmpty(sales.total) && <S.Badge>상위 {rate}%</S.Badge>}
          </S.TitleWrapper>
          <S.SubTitleWrapper>
            <S.SubTitle isEmpty={isEmpty(sales.perPerson)}>
              <Text typography='midium120_C1'>1인당 매출액</Text>
              <Text typography='bold120_C1'>{displaySales(sales.perPerson, 'person')}</Text>
            </S.SubTitle>
            <S.SubTitle isEmpty={isEmpty(sales.salesSalaryRate)}>
              <Text typography='midium120_C1'>매출 대비 임금</Text>
              <Text typography='bold120_C1'>{displaySales(sales.salesSalaryRate, 'salary')}</Text>
            </S.SubTitle>
          </S.SubTitleWrapper>
          <S.Source typography='midium150_C1'>
            출처 :{' '}
            {!isEmpty(sales.source) && !isEmpty(sales.total)
              ? `${SalesSource[sales.source]} ${
                  sales.updatedAt ? dayjs(sales.updatedAt).format('YYYY.MM') : ''
                }`
              : '정보없음'}
          </S.Source>
        </S.Content>
      ) : (
        <S.Content>
          <Text typography={isMobile ? 'bold150_T1' : 'bold150_B1'}>비공개</Text>
        </S.Content>
      )}
    </S.SummaryCardItem>
  );
}

export default SalesCard;
